if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener(
            'submit',
            this.handleSubmit.bind(this)
          );
        }

        // Let the page finish loading its Liquid configuration first.
        window.setTimeout(() => {
          if (
            !this.isConnected ||
            !this.submitBtn ||
            !this.getB2BLimit() ||
            theme.settings.afterAtc === 'no-js'
          ) {
            return;
          }

          this.refreshB2BLimit();

          this.b2bLimitTimer = window.setInterval(() => {
            if (!this.isConnected) {
              window.clearInterval(this.b2bLimitTimer);
              return;
            }

            if (!document.hidden) {
              this.refreshB2BLimit();
            }
          }, 3000);
        }, 0);
      }
    }

    getB2BLimit() {
      const limit = window.GRIMM_B2B_TOTAL_LIMIT;

      if (
        !limit ||
        !Array.isArray(limit.variantIds) ||
        !Number.isInteger(limit.maximum) ||
        limit.maximum < 1
      ) {
        return null;
      }

      const variantId = Number(
        new FormData(this.form).get('id')
      );

      const applies = limit.variantIds.some(
        (id) => Number(id) === variantId
      );

      return applies ? limit : null;
    }

    getB2BRemaining(cart, limit) {
      const total = cart.items.reduce((sum, item) => {
        if (Number(item.product_id) === Number(limit.productId)) {
          return sum + Number(item.quantity);
        }

        return sum;
      }, 0);

      return Math.max(0, limit.maximum - total);
    }

    getB2BLimitMessage(limit, remaining) {
      if (remaining === 0) {
        return (
          `Maks ${limit.maximum} enheter totalt av dette produktet. ` +
          'Maksantallet er allerede lagt i handlekurven.'
        );
      }

      return (
        `Maks ${limit.maximum} enheter totalt av dette produktet. ` +
        `Du kan legge til ${remaining} flere.`
      );
    }

     async refreshB2BLimit() {
      const limit = this.getB2BLimit();
      const button = this.querySelector('[name="add"]');

      if (
        !limit ||
        !button ||
        this.b2bRefreshPending ||
        button.classList.contains('is-loading')
      ) {
        return;
      }

      this.b2bRefreshPending = true;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(
          `${root}cart.js?_grimm=${Date.now()}`,
          { cache: 'no-store' }
        );

        if (!response.ok) return;

        const cart = await response.json();

        if (
          !Array.isArray(cart.items) ||
          !this.isConnected ||
          button.classList.contains('is-loading')
        ) {
          return;
        }

        const remaining = this.getB2BRemaining(cart, limit);
        const quantityField = this.form.querySelector('[name="quantity"]');
        const parsedMinimum = Number(quantityField?.min || 1);
        const minimum = (
          Number.isInteger(parsedMinimum) && parsedMinimum > 0
        ) ? parsedMinimum : 1;

        if (remaining < minimum) {
          if (
            button.dataset.grimmLimitBlocked === 'true' ||
            (!button.disabled &&
              button.getAttribute('aria-disabled') !== 'true')
          ) {
            button.dataset.grimmLimitBlocked = 'true';
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          }

          this.b2bLimitMessageShown = true;
          this.setErrorMsgState(
            this.getB2BLimitMessage(limit, remaining)
          );
        } else {
          if (button.dataset.grimmLimitBlocked === 'true') {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            delete button.dataset.grimmLimitBlocked;
          }

          if (this.b2bLimitMessageShown) {
            this.b2bLimitMessageShown = false;
            this.setErrorMsgState();
          }
        }
      } catch (error) {
        console.warn('Kunne ikke oppdatere B2B-grensen.', error);
      } finally {
        this.b2bRefreshPending = false;
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.b2bLimitMessageShown = false;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const embroidery = this.form.querySelector('[data-grimm-embroidery]');
      const embroideryOn = embroidery && !embroidery.querySelector('[data-grimm-embroidery-fields]').hidden;
      let embroideryKey = '';
      let embroideryFeeId = 0;
      let embroideryLabel = '';
      if (embroideryOn) {
        const status = embroidery.querySelector('select[name="properties[Logostatus]"]')?.value || '';
        const previous = embroidery.querySelector('input[name="properties[Logo fra tidligere ordre]"]')?.value.trim() || '';
        const name = embroidery.querySelector('input[name="properties[Logonavn]"]')?.value.trim() || '';
        if (!status || (status.startsWith('Eksisterende') && !previous)) {
          this.setErrorMsgState('Velg logostatus og oppgi tidligere ordre eller salongnavn ved gjenbestilling.');
          this.submitBtn.removeAttribute('aria-disabled');
          this.submitBtn.classList.remove('is-loading');
          return;
        }
        const fresh = status.startsWith('Ny logo');
        embroideryFeeId = fresh ? 47965023764720 : 47965027336432;
        embroideryKey = fresh ? 'ny-logo:' + (name.toLowerCase() || 'standard') : 'tidligere:' + previous.toLowerCase();
        embroideryLabel = fresh ? (name || 'Ny logo – navn ikke oppgitt') : 'Tidligere ordre: ' + previous;
      }
      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      if (embroideryOn) formData.set('properties[_Logoidentifikator]', embroideryKey);
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      let submissionSucceeded = false;

      try {
        const oldCartResponse = await fetch(
          `${theme.routes.cart}.js`,
          { cache: 'no-store' }
        );

        if (!oldCartResponse.ok) {
          throw new Error(oldCartResponse.status);
        }

        const oldCartData = await oldCartResponse.json();

        // B2B maximum: total across all variants of this product.
        const limit = this.getB2BLimit();

        if (limit) {
          const remaining = this.getB2BRemaining(
            oldCartData,
            limit
          );

          const requested = Number(
            formData.get('quantity') || 1
          );

          if (
            !Number.isInteger(requested) ||
            requested < 1 ||
            requested > remaining
          ) {
            this.setErrorMsgState(
              this.getB2BLimitMessage(limit, remaining)
            );
            return;
          }
        }

        const response = await fetch(
          theme.routes.cartAdd,
          fetchRequestOpts
        );

        const data = await response.json();

        let error = typeof data.description === 'string'
          ? data.description
          : data.message;

        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map(
            (item) => item[1].join(', ')
          );
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (embroideryOn) {
          try {
            const current = await (await fetch(theme.routes.cart + '.js', {cache:'no-store'})).json();
            const exists = current.items.some(item => Number(item.variant_id) === embroideryFeeId && item.properties?.['_Logoidentifikator'] === embroideryKey);
            if (!exists) {
              const fee = await fetch(theme.routes.cartAdd, {
                method:'POST',
                headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({items:[{id:embroideryFeeId,quantity:1,properties:{'_Logoidentifikator':embroideryKey,'Oppstart':'Brodering','Gjelder logo':embroideryLabel}}]})
              });
              if (!fee.ok) throw Error('Oppstart kunne ikke legges til');
            }
            submissionSucceeded = true;
            window.location.href = theme.routes.cart;
            return;
          } catch (error) {
            this.setErrorMsgState('Oppstartskostnaden mangler. Kontakt GRIMM før betaling.');
            window.location.href = theme.routes.cart;
            return;
          }
        }
        submissionSucceeded = true;

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete.
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer,
          // show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');

          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');

              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(
          `${theme.routes.cart}.js`,
          { cache: 'no-store' }
        );

        if (!newCartResponse.ok) {
          throw new Error(newCartResponse.status);
        }

        const newCartData = await newCartResponse.json();

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart.
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity
                : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        if (submissionSucceeded) {
          this.submitBtn.classList.add('is-success');
        }

        // Keep the button locked until the loading state ends.
        setTimeout(async () => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
          this.submitBtn.removeAttribute('aria-disabled');

          await this.refreshB2BLimit();
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');

      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;

      if (error) {
        this.errorMsg.innerHTML = '';

        const errorArray = Array.isArray(error) ? error : [error];

        errorArray.forEach((err, index) => {
          if (index > 0) {
            this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          }

          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
